(ns com.theplantscape.plant-web.draw.helpers
  (:require
   [reitit.impl :refer [url-encode]]))

(def date-inst (js/Date.))
(defn get-millis [] (.getTime (js/Date.)))



(defn create-onload-reader
  "Create a js reader with an onload event"
  [callback]
  (let [reader (js/FileReader.)]
    (set! (.-onload reader) callback)
    reader))

